<!--
 * @Description: 新增合同模板/编辑
 * @Author: 钱磊
 * @Date: 2022-08-31 14:18:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-13 17:07:35
-->
<!--  -->
<template>
	<div>
		<el-form ref="addTemp" :model="addTempForm" size="medium" :rules="addRule" label-width="110px">
			<el-row class="mt10">
				<el-col :span="18">
					<el-form-item label="模板名称：" prop="docTemplateName">
						<el-input size="small" v-model="addTempForm.docTemplateName" placeholder="请输入模板名称" maxlength="30" clearable></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="mt10">
				<el-col :span="18">
					<el-form-item label="应用业务：" prop="bizType">
						<el-radio-group v-model="addTempForm.bizType" @change="handelChange">
							<el-radio-button v-for="(item, index) of yyyw" :key="index" :label="item.code" :disabled="item.childs.length == 0">{{
								item.name
							}}</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="mt10">
				<el-col :span="18">
					<el-form-item label="业务场景：" prop="bizScene">
						<el-radio-group v-model="addTempForm.bizScene">
							<el-radio v-for="(item, index) of ywcj" :key="index" :label="item.code">{{ item.name }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="mt10">
				<el-col :span="18">
					<el-form-item label="内容：" required>
						<wang-editor v-model="addTempForm.content" ref="wangEditor" height="100%"></wang-editor>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="mt10">
				<el-col :span="18">
					<el-form-item>
						<el-button type="primary" size="medium" :loading="btnLoading" @click="doNext">下一步</el-button>
						<el-button type="success" size="medium" :loading="btnLoading" @click="submit('save')">暂保存</el-button>
						<el-button size="medium" @click="goBack">取消</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<!-- 弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:title="dialogObj.title"
			center
			class="add-dialog"
			:close-on-click-modal="false"
		>
			<p v-if="this.dialogObj.type == 'add'">
				请确定合同模板内容不需要再修改，确定后该合同模板将会上传E签宝，上传后模板将不能被<span class="red">删除</span>
			</p>
			<p v-else>
				该合同模板已上传E签宝，请确定是否需要替换原上传E签宝的合同模板
			</p>
			<!-- footer 组件 -->
			<div slot="footer" class="pdb10 text-center" v-if="this.dialogObj.type == 'add'">
				<el-button type="primary" size="small" class="btn btn-blue" @click="submit('next', 1)" :loading="dialogObj.btnLoading"
					>确 定
				</el-button>
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
			</div>
			<div slot="footer" class="pdb10 text-center" v-else>
				<el-button type="primary" size="small" class="btn btn-blue" @click="submit('next', 0)">不需要 </el-button>
				<el-button size="small" class="btn" @click="submit('next', 1)" :loading="dialogObj.btnLoading">替换原合同模板 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as API from 'api/modules/es/es_template.js'
export default {
	data() {
		return {
			addTempForm: {
				id: '',
				docTemplateName: '',
				bizType: '',
				bizScene: '',
				content: '',
				action: '',
				isRepl: ''
			},
			addRule: {
				docTemplateName: [{ required: true, message: '不能为空', trigger: 'blur' }],
				bizType: [{ required: true, message: '请选择应用业务', trigger: 'change' }],
				bizScene: [{ required: true, message: '请选择业务场景', trigger: 'change' }]
			},
			btnLoading: false,
			yyyw: [], //应用业务
			ywcj: [], //应用场景
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '600px',
				title: '提示',
				type: 'add',
				btnLoading: false
			},
			templateId: {} //编辑时的id
		}
	},
	mounted() {
		if (this.$getSessionItem('templateId')) {
			this.templateId = JSON.parse(this.$getSessionItem('templateId'))
			this.getDict().then((res) => {
				this.getTemplate()
			})
		}
		this.getDict()
	},
	methods: {
		//获取应用业务码表
		getDict() {
			return new Promise((resolve, reject) => {
				API.getDict({}).then((res) => {
					this.yyyw = res.data
					resolve()
				})
			})
		},
		// 当编辑时查询改模板的信息
		getTemplate() {
			API.getInfoById({ id: this.templateId }).then((res) => {
				this.addTempForm = Object.assign({}, res.data)
				this.handelChange(this.addTempForm.bizType)
			})
		},
		//当应用业务发生改变后，切换业务场景
		handelChange(val) {
			let arr = this.yyyw.find((item) => item.code == val)
			this.ywcj = arr ? arr.childs : ''
		},
		//下一步
		doNext() {
			if (this.routeQuery == 'add') {
				this.dialogObj.type = 'add'
				this.dialogObj.visible = true
			} else {
				if (this.addTempForm.docTemplateCreateUrl == '') {
					this.dialogObj.type = 'add'
					this.dialogObj.visible = true
					return
				}

				this.dialogObj.type = 'edit'
				this.dialogObj.visible = true
			}
		},
		//提交下一步
		submit(action, isRepl) {
			let status = false
			this.$refs.addTemp.validate((valid) => {
				if (valid) {
					if (this.addTempForm.content != '') {
						status = true
					} else {
						status = false
					}
				} else {
					status = false
				}
			})
			if (status) {
				this.addTempForm.action = action
				this.addTempForm.isRepl = isRepl
				let params = Object.assign({}, this.addTempForm)
				API.addTemplateFromHtml(params).then((res) => {
					if (res.operationCode == 1) {
						if (action == 'save') {
							this.goBack()
						} else {
							let data = res.data
							this.$setSessionItem('contractData', JSON.stringify(data))
							this.$router.push({
								path: '/es-contract-template-maintain-new',
								query: {
									type: 'template'
								}
							})
						}
					}
				})
			} else {
				this.$message.warning('请完成必填项！')
			}
		},
		//返回
		goBack() {
			this.$emit('close')
			this.$router.push({
				path: '/es-contract-template-maintain-new'
			})
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style scoped lang="less">
/deep/ .el-radio-button {
	width: 200px !important;
	margin-right: 20px;
}
/deep/ .el-radio-group {
	display: flex;
	flex-wrap: wrap;
}
/deep/ .el-radio-button__inner {
	border: 1px solid #dcdfe6 !important;
	margin-top: 10px !important;
	width: 100%;
	display: inline-block;
	border-radius: 4px !important;
}
/deep/.el-radio {
	line-height: 36px;
}
.expertStandard {
	// /deep/.editor .ql-container {
	//   max-height: 350px !important;
	//   min-height: 200px !important;
	// }
	// /deep/div.ql-editor {
	//   max-height: 350px !important;
	//   min-height: 200px !important;
	// }
}
.red {
	color: red;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
	box-shadow: none;
}
.main-page-container {
	background-color: #fff;
}
</style>
